import React from "react";

export const NaturalGas = [
    <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">Why is natural gas good?</h4>
    <div class="video_container">
      <video width="320" height="240" controls poster="videos/natural-gas-video-poster.jpg">
        <source
          src="videos/Why-is-natural-gas-good.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-why-is-natural-gas-good.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <>
    <h4 className="slideTitle">Shell: A Global Leader in Natural Gas</h4>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <p>
          <strong>
            Natural gas will be an essential part of the future energy mix as
            the world moves to a low-carbon future.
          </strong>
        </p>
        <p>
          Natural gas is the cleanest-burning hydrocarbon, producing around half
          the greenhouse gas emissions and less than one-tenth of the air
          pollutants that coal does when burnt to generate electricity.
        </p>
        <p>
          It is one of the few energy sources that can be used across all
          sectors of the global economy – to generate electricity, provide heat
          for essential industrial processes, heat homes and fuel the transport
          of people and goods. Natural gas supports the integration of variable
          renewable electricity generation.
        </p>
      </div>
      <div className="colRight col50 solidColourContainer stats">
        <div class="d-flex">
          <p className="figureContainer">
            <span className="figure">50 years</span>
            <br />
            Shell has been a pioneer in LNG for more than five decades: from
            finding the fields and extracting the gas, through to liquefaction,
            shipping and distribution to customers
          </p>
        </div>
      </div>
    </div>
  </>,
  <>
    <h4 className="slideTitle">Shell: A Global Leader in Natural Gas</h4>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50 solidColourContainer grey stats">
        <div class="d-flex">
          <p className="figureContainer">
            <span className="figure">290 million</span>
            <br />
            cubic metres of gas produced by Shell globally every day
          </p>
        </div>
      </div>
      <div className="colRight col50 solidColourContainer stats">
        <div class="d-flex">
          <p className="figureContainer">
            <span className="figure">74 million</span>
            <br />
            tonnes of LNG sold in 2019, driven by our increased LNG purchases
            from third parties and higher LNG liquefaction volumes
          </p>
        </div>
      </div>
    </div>
  </>,
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col60">
      <h4 className="slideTitle">
        Shell Energy Europe works with you to tailor gas solutions that best
        suit your needs
      </h4>
      <p>
        With around 20 billion cubic metres of gas supplied to customers every
        year, we are one of the leading gas traders and marketers in Europe.
      </p>
      <p className="mb-2">
        <strong>Trading</strong>
      </p>
      <ul className="shell_bullets_list">
        <li>Physical and financial</li>
        <li>
          Fixed price spot and forwards, swaps, vanilla options, location /time
          swaps, spark spreads
        </li>
        <li>Flat tradable and nontradable volumes, profiles</li>
      </ul>
      <p className="mb-2">
        <strong>Flexibility and Capacity</strong>
      </p>
      <ul className="shell_bullets_list">
        <li>Physical and virtual storage</li>
        <li>Interruptability</li>
        <li>Physical and virtual transport</li>
        <li>Balancing agreements</li>
      </ul>
      <p className="mb-2">
        <strong>Clean Energy</strong>
      </p>
      <ul className="shell_bullets_list">
        <li>Reduced carbon gas</li>
        <li>Renewable gas</li>
      </ul>
    </div>
    <div className="colRight col40 solidColourContainer textBox">
      <p className="mb-2">
        <strong>Price Options</strong>
      </p>
      <ul className="shell_bullets_list">
        <li>Physical and financial</li>
        <li>Option to fix and unfix</li>
        <li>Blend and extend</li>
        <li>Caps, floors, collars</li>
        <li>Discounted index</li>
        <li>Oil and gas swing contracts</li>
        <li>Time spread options</li>
      </ul>
      <p className="mb-2">
        <strong>Index Supply</strong>
      </p>
      <ul className="shell_bullets_list">
        <li>Gas hub indices (NBP, TTF, NCG, GP, PSV, PEG, CEGH, VTP)</li>
        <li>Temperature regression</li>
        <li>Combination of indices</li>
        <li>Deliveries at borders, virtual points, city gates, plants</li>
        <li>Swing or fixed supply</li>
      </ul>
    </div>
  </div>,
];
